import {Store} from './store';
import eventPropertiesClient from 'common/report/queries/query-api/event-properties-client';

export interface EventProperties {
  [eventNames: string]: Array<Record<string, any>>;
}

export default new Store<EventProperties>({
  apiClient: eventPropertiesClient,

  // in an app, different properties-menu instances can have different properties they need to show
  // based on the event names given to them. here we maintain a map of fetch params to property lists
  transform: {
    index: (response, params, options) => ({[Store.getKey(params, options)]: response}),
  },

  defaultValue: {},
});
